// @ts-nocheck
import classNames from 'clsx'

import './CrosssellWideSkeleton.scss'

export const renderItems = ({ items }) =>
  items.map((_, index) => (
    <li
      className={classNames(
        'l-flex o-SkeletonSliderItemWrapper l-col--12-of-12 l-col--6-of-12@tiny',
        {
          'u-hidden@small-tiny': index >= 2,
        }
      )}
      key={`slider-item-${index}`}
    >
      <div className="o-SkeletonSliderItem__left a-full-width" />
      <div className="o-SkeletonSliderItem__right a-full-width l-flex l-flex--start l-flex__column u-padding">
        <div className="o-SkeletonSliderItem__text u-margin-x-small--bottom a-full-width" />
        <div className="o-SkeletonSliderItem__Stars o-SkeletonSliderItem__text" />

        <div className="u-margin--top a-full-width">
          <div className="o-SkeletonSliderItem__Prices o-SkeletonSliderItem__text a-full-width u-margin-x-small--bottom" />
          <div className="o-SkeletonSliderItem__Unit-Price o-SkeletonSliderItem__text a-full-width" />
        </div>
      </div>
    </li>
  ))

const CrosssellWideSkeleton = () => {
  const numberOfVisibleItems = 3
  const items = new Array(numberOfVisibleItems).fill(true)

  const productRow = (
    <ul className="o-CrosssellWideSkeleton__items">
      <div className="a-full-width l-flex">{renderItems({ items })}</div>
      <div className="u-hidden@medium l-flex l-flex--center u-margin--top">
        <div className="o-SkeletonSliderItem__dot u-background-color--greyLight u-border-radius" />
        <div className="o-SkeletonSliderItem__dot u-background-color--greyLight u-border-radius u-margin-small--left" />
        <div className="o-SkeletonSliderItem__dot u-background-color--greyLight u-border-radius u-margin-small--left" />
      </div>
    </ul>
  )

  return (
    <div className="o-CrosssellWideSkeleton">
      <div className="o-CrosssellWideSkeleton__header" />
      {productRow}
    </div>
  )
}

export default CrosssellWideSkeleton
